import angular from 'angular';

import '../../../main/factory/acquirer';
import '../../../main/factory/authentication';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.acquirers.list", [
]).controller("merchant.application.module.acquirers.list.controller", [
    "$scope", "$controller", "$window",
    "merchant.application.main.factory.acquirer",
    "merchant.application.main.factory.authentication",
    function($scope, $controller, $window, Acquirer, Authentication) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.acquirersList) {
            $scope.model.acquirersList = {};
        }
        $scope.model.acquirersList.data = {};
        $scope.model.acquirersList.populating = false;

        $scope.populate = function() {
            if (! $scope.model.acquirersList.populating) {
                $scope.model.acquirersList.populating = true;
                var parameters = {
                    coreMerchantId: Authentication.merchantId()
                };

                Acquirer.populate(parameters, function(data) {
                    $scope.model.acquirersList.data = data;
                    $scope.model.acquirersList.populating = false;
                }, function() {
                    $scope.model.acquirersList.populating = false;
                });
            }
        };

        $scope.$on("newAcquirer", function() {
            $scope.openAcquirerModal(null);
        });

        $scope.openAcquirerModal = function(ref) {
            $scope.model.ref = ref;
            $scope.model.modulesIncludedInModal = ["acquirer.html"];
            $scope.model.isModalVisible = true;
            $scope.model.modalName = "acquirer";
        };

        $scope.edit = function(acquirer) {
            $scope.openAcquirerModal(acquirer.ref)
        };

        $scope.delete = function(acquirer) {
            if ($window.confirm("Are you sure?")) {
                Acquirer.delete({
                    ref: acquirer && acquirer.ref,
                    coreMerchantId: Authentication.merchantId()
                }, function() {
                    $scope.populate();
                }, angular.noop); // No errors to display
            }
        };

        $scope.$watch("model.isModalVisible", function(isVisible) {
            if (! isVisible && $scope.model.modalName === "acquirer") {
                $scope.populate();
            }
        });
    }
]);
